import React, { useState, useEffect } from 'react';
import { Redirect, Link } from 'react-router-dom';


import 'react-accessible-accordion/dist/fancy-example.css';

import DataTable from 'react-data-table-component';

import { reqGET } from '../../../Utils';
import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from '../../../UseToken';

export default function View(props) {

    const [dados, set_dados] = useState(data_interface);

    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);
    const [hideEmpresarial, set_hide_empresarial] = useState('')
    const [data_creditos, set_credits] = useState([]);
    //const [hidePessoal, set_hide_pessoal] = useState('')

    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState({});
    const [expandedDept, setExpandedDept] = useState(null);

    const columns_creditos = [
        {
            name: <div className="table-header">Proposta</div>,
            sortable: true,
            maxWidth: '100px',
            selector: 'proposta',
            left: true,
        },
        {
            name: <div className="table-header">Escritório</div>,
            selector: 'escritorio',
            sortable: true,
            left: true,
        },
        {
            name: <div className="table-header">Responsável</div>,
            selector: 'responsavel',
            sortable: true,
            left: true,
        },
        {
            name: <div className="table-header">Promotor</div>,
            selector: 'promotor',
            sortable: true,
            left: true,
        },
        {
            name: <div className="table-header">Tipo de Crédito</div>,
            selector: 'tipo_credito',
            sortable: true,
            left: true,
        },
        {
            name: <div className="table-header">Valor Financiado</div>,
            cell: row => <div>{row.valor_financiado}€</div>,
            maxWidth: '150px',
            sortable: true,
            left: true,
        },
        {
            name: <div className="table-header">Estado</div>,
            cell: row => 'Saber mais +',
            maxWidth: '150px',
            left: true,
        },
    ];

    //const ExpandableComponent = ({ data }) => <span>###{data.proposta}###</span>;
    const ExpandableComponent = ({ data }) =>
        <div className="div-expand">
            <div dangerouslySetInnerHTML={{ __html: data.timeline }} />
        </div>;

    const defaultComponentOptions = {
        rowsPerPageText: 'Registos por página:',
        rangeSeparatorText: 'de',
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: 'Todos',
        responsive: true,
    };

    const load_credits = async (id) => {

        reqGET(`${api_crud_base}/credits/credits/special/credits/Promotor/${getTokenInfo().companycode}/${id}`)
            .then(res => {
                //console.log(res.data)
                set_credits(...[
                    res.data.map(k => {
                        let aux_estado = '';
                        let aux_timeline = '<div><ul class="timeline">';
                        var i = 0;
                        if (k.info.estado)
                            k.info.estado.forEach((v_1) => {

                                i++;
                                var j = 0;
                                v_1.etapas.forEach((v_2) => {
                                    if (i === 5) {
                                        i = 1;
                                        aux_timeline = aux_timeline + '</ul><ul class="timeline">';
                                    }

                                    if (v_1.data.localeCompare("") !== 0) {
                                        if (v_2.activo) {
                                            if (v_2.value.localeCompare(v_2.sucesso.id) === 0) {
                                                aux_timeline = aux_timeline + '<li class="completed">'
                                                    + '<div class="timestamp">'
                                                    + '<span class="author"></span>'
                                                    + '<span class="date"></span>'
                                                    + '</div>'
                                                    + '<div class="status">'
                                                    + '<h4>' + v_1.label + '</h4>'
                                                    + '</div>'
                                                    + '<div class="on-course">'
                                                    + '<h4 class="on-course">em curso</h4>'
                                                    + '</div>'
                                                    + '</li>';
                                            }
                                            else if (v_2.value.localeCompare(v_2.insucesso.id) === 0) {
                                                aux_estado = 'Cancelado';
                                                aux_timeline = aux_timeline + '<li class="error">'
                                                    + '<div class="timestamp">'
                                                    + '<span class="author"></span>'
                                                    + '<span class="date"></span>'
                                                    + '</div>'
                                                    + '<div class="status">'
                                                    + '<h4>' + v_1.label + '</h4>'
                                                    + '</div>'
                                                    + '<div class="on-course">'
                                                    + '<h4 class="on-course">em curso</h4>'
                                                    + '</div>'
                                                    + '</li>';

                                            }
                                            else {
                                                aux_estado = v_1.label;
                                                aux_timeline = aux_timeline + '<li class="on-course">'
                                                    + '<div class="timestamp">'
                                                    + '<span class="author"></span>'
                                                    + '<span class="date"></span>'
                                                    + '</div>'
                                                    + '<div class="status">'
                                                    + '<h4>' + v_1.label + '</h4>'
                                                    + '</div>'
                                                    + '<div class="on-course">'
                                                    + '<h4 class="on-course">em curso</h4>'
                                                    + '</div>'
                                                    + '</li>';
                                            }
                                        }
                                    }
                                    else {
                                        if (j === 0) {
                                            j++;
                                            aux_timeline = aux_timeline + '<li class="">'
                                                + '<div class="timestamp">'
                                                + '<span class="author"></span>'
                                                + '<span class="date"></span>'
                                                + '</div>'
                                                + '<div class="status">'
                                                + '<h4>' + v_1.label + '</h4>'
                                                + '</div>'
                                                + '<div class="on-course">'
                                                + '<h4 class="on-course">em curso</h4>'
                                                + '</div>'
                                                + '</li>';
                                        }
                                    }

                                })

                            });
                        if (k.info.workflow)
                            k.info.workflow.forEach((v_1) => {
                                i++;
                                var j = 0;
                                if (v_1.estado)
                                    v_1.estado.forEach((v_2) => {
                                        if (i === 5) {
                                            i = 1;
                                            aux_timeline = aux_timeline + '</ul><ul class="timeline">';
                                        }

                                        if (v_1.data.localeCompare("") !== 0) {
                                            if (v_2.selected) {
                                                //console.log(v_2.selected)
                                                if (v_2.pendente === false && v_2.completo === true) {
                                                    aux_timeline = aux_timeline + '<li class="completed">'
                                                        + '<div class="timestamp">'
                                                        + '<span class="author"></span>'
                                                        + '<span class="date"></span>'
                                                        + '</div>'
                                                        + '<div class="status">'
                                                        + '<h4>' + v_1.name + '</h4>'
                                                        + '</div>'
                                                        + '<div class="on-course">'
                                                        + '<h4 class="on-course">em curso</h4>'
                                                        + '</div>'
                                                        + '</li>';
                                                }
                                                else if (0) {
                                                    aux_estado = 'Cancelado';
                                                    aux_timeline = aux_timeline + '<li class="error">'
                                                        + '<div class="timestamp">'
                                                        + '<span class="author"></span>'
                                                        + '<span class="date"></span>'
                                                        + '</div>'
                                                        + '<div class="status">'
                                                        + '<h4>' + v_1.name + '</h4>'
                                                        + '</div>'
                                                        + '<div class="on-course">'
                                                        + '<h4 class="on-course">em curso</h4>'
                                                        + '</div>'
                                                        + '</li>';

                                                }
                                                else {
                                                    aux_estado = v_1.label;
                                                    aux_timeline = aux_timeline + '<li class="on-course">'
                                                        + '<div class="timestamp">'
                                                        + '<span class="author"></span>'
                                                        + '<span class="date"></span>'
                                                        + '</div>'
                                                        + '<div class="status">'
                                                        + '<h4>' + v_1.name + '</h4>'
                                                        + '</div>'
                                                        + '<div class="on-course">'
                                                        + '<h4 class="on-course">em curso</h4>'
                                                        + '</div>'
                                                        + '</li>';
                                                }
                                            }
                                        }
                                        else {
                                            if (j === 0) {
                                                j++;
                                                aux_timeline = aux_timeline + '<li class="">'
                                                    + '<div class="timestamp">'
                                                    + '<span class="author"></span>'
                                                    + '<span class="date"></span>'
                                                    + '</div>'
                                                    + '<div class="status">'
                                                    + '<h4>' + v_1.name + '</h4>'
                                                    + '</div>'
                                                    + '<div class="on-course">'
                                                    + '<h4 class="on-course">em curso</h4>'
                                                    + '</div>'
                                                    + '</li>';
                                            }
                                        }

                                    })

                            });
                        aux_timeline += '</ul></div>';

                        return {
                            proposta: k['id'],
                            escritorio: k.info.escritorio['name'],
                            responsavel: k.info.responsavel['name'],
                            promotor: k.info.promotor['name'],
                            tipo_credito: k.info.tipo_credito['name'],
                            valor_financiado: k.commissioning['valor_financiado'],
                            estado: aux_estado,
                            timeline: aux_timeline
                        }

                    })
                ])
                //console.log(credits)
            })
    }

    const toggleExpand = (id) => {
        setExpandedDept(expandedDept === id ? null : id);
    };


    // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {
        await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
            .then(res => {
                set_dados(res.data[0]);

                console.log(res.data[0])

            })
            .catch(() => 404
                //  TODO: ENVIAR PÝGINA 404
                //  alert(error)); 
            );
    }

    const handleModalShow = (responsavel) => {
        setModalContent(responsavel);
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    useEffect(() => {

        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id']).then(() => setLoading(false))
        }
        else {
            setLoading(false);
            setRedirect(true);
        }

    }, [props]);



    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?
            <main>
                <div className={`dash-cards-2 header`}>
                    <h2 className="dash-title">LOADING</h2>
                    <p>LOADING</p>
                    <div className="overlay">
                        <div className="overlay__inner">
                            <div className="overlay__content"><span className="spinner"></span></div>
                        </div>
                    </div>
                </div>
            </main>
            :
            <main>
                <div style={{ flexDirection: 'column', margin: '0 auto', padding: '25px', fontFamily: 'Arial, sans-serif', backgroundColor: '#f4f4f4' }}>
                    <div style={{ marginBottom: '25px', padding: '25px', backgroundColor: '#fff', borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
                        <h2>Detalhes da Empresa</h2>
                        <p><strong>Nome:</strong> {dados.info.name}</p>    
                        <p><strong>NIF:</strong> {dados.info.vat}</p>                    
                        <p><strong>Código da Empresa:</strong> {dados.info.companycode}</p>                        
                        {/* <p><strong>Tipo de Entidade:</strong> {dados.info.entity_type}</p>*/}
                        {/*<p><strong>Validade da Identificação:</strong> {dados.info.identificacao.validade_identificacao}</p>*/}
                        <p><strong>Observações:</strong> {dados.info.observation}</p>
                    </div>

                    <div style={{ marginBottom: '25px', padding: '25px', backgroundColor: '#fff', borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
                        {dados.addresses.map((address, index) => (
                            <div key={index}>
                                <h2>Endereços da Empresa</h2>
                                <p><strong>País:</strong> {address.country}</p>
                                <p><strong>Região:</strong> {address.region}</p>
                                <p><strong>Cidade:</strong> {address.city}</p>
                                <p><strong>Freguesia:</strong> {address.village}</p>    
                                <p><strong>Localidade:</strong> {address.localidade}</p>                                                    
                                <p><strong>Morada:</strong> {address.street_name}{address.address_detail}</p>
                                <p><strong>Código Postal:</strong> {address.postal_code}</p>
                                {/*<p><strong>Tipo:</strong> {address.type.join(', ')}</p>*/}
                                <p><strong>Observações:</strong> {address.observation}</p>
                            </div>
                        ))}
                    </div>

                    <div style={{ marginBottom: '25px', padding: '25px', backgroundColor: '#fff', borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
                        {dados.contacts.map((contact, index) => (
                            <div key={index}>
                                <h2>Contactos da Empresa</h2>
                                <p><strong>Email:</strong> {contact.email}</p>
                                <p><strong>Telemóvel:</strong> {contact.mobile_phone}</p>
                                {/*<p><strong>Telefone:</strong> {contact.phone}</p>*/}
                                {/*<p><strong>Número do Edifício:</strong> {contact.building_number}</p>*/}
                                {/*<p><strong>Extensões:</strong> {contact.extensions.join(', ')}</p>*/}
                                <p><strong>Observações:</strong> {contact.observation}</p>
                            </div>
                        ))}
                    </div>

                    <div style={{ marginBottom: '25px', padding: '25px', backgroundColor: '#fff', borderRadius: '5px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
                        {dados.contacts.map((contact) => (
                            <div key={contact.id}>
                                <h2>Departamentos</h2>
                                {contact.departamentos.map((departamento) => (
                                    <div key={departamento.id}>
                                        <button
                                            style={{
                                                width: '100%',
                                                padding: '8px',
                                                marginTop: '5px',
                                                backgroundColor: '#fff',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                cursor: 'pointer',
                                                textAlign: 'left'
                                            }}
                                            onClick={() => toggleExpand(departamento.id)}
                                        >
                                            {departamento.nome}
                                        </button>
                                        {expandedDept === departamento.id && (
                                            <div
                                                style={{
                                                    paddingLeft: '10px',
                                                    marginTop: '5px',
                                                    backgroundColor: '#f9f9f9',
                                                    borderRadius: '4px',
                                                }}
                                            >
                                                {contact.person_responsables
                                                    .filter((responsavel) =>
                                                        responsavel.departamentos && responsavel.departamentos.includes(departamento.id)
                                                    )
                                                    .map((responsavel) => (
                                                        <div
                                                            key={responsavel.id}
                                                            style={{
                                                                padding: '5px',
                                                                backgroundColor: '#fff',
                                                                borderRadius: '4px',
                                                                marginBottom: '5px',
                                                            }}
                                                        >
                                                            <p><strong>Nome:</strong> {responsavel.name}</p>
                                                            <p><strong>Telemóvel:</strong> {responsavel.mobile_phone}</p>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleModalShow(responsavel)}
                                                                className="btn btn-default btn-sm me-2"
                                                            >
                                                                Ver Detalhes
                                                            </button>
                                                        </div>
                                                    ))}
                                            </div>
                                        )}

                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>

                    {showModal && (
                        <div style={{
                            position: 'fixed',
                            top: '0',
                            left: '0',
                            width: '100%',
                            height: '100%',
                            background: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                background: '#fff',
                                padding: '20px',
                                borderRadius: '4px',
                                width: '300px',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                textAlign: 'left'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    width: '100%',
                                    alignItems: 'center'
                                }}>
                                    <h4 style={{ margin: '0' }}>Detalhes do Responsável</h4>
                                    <button
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#fff',
                                            border: 'none',
                                            padding: '5px 10px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={handleModalClose}
                                    >
                                        X
                                    </button>
                                </div>
                                <p style={{ marginTop: '15px' }}><strong>Nome:</strong> {modalContent.name}</p>
                                <p><strong>Telemóvel:</strong> {modalContent.mobile_phone}</p>
                            </div>
                        </div>
                    )}
                </div>

                <div className={'dash-cards-2 footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">
                            <ul className="navbar-nav float-left"></ul>
                            <ul className="navbar-nav float-right">
                                <li className="nav-item">
                                    <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
                                        <img alt='' src={'./img/seta_2.svg'} />
                                        <span>Voltar</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </main>
}